import React, { memo } from 'react'

import {
  Icon, InfoOutlined, Progress, Tooltip,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { number, string } from 'prop-types'

import useBreakpoint from 'Utils/useBreakpoint'

// Centered above the count, the tooltip runs past the right edge of the viewport once
// the modal stops being centered in a wide window; from `md` down it opens to the left
// of the icon instead, where the modal always has room.
const NARROW_BREAKPOINTS = ['xs', 'sm']

function ProgressBar({
  label, used, total, tooltip = '', tooltipId = '',
}) {
  const breakpoint = useBreakpoint()
  const tooltipPlace = NARROW_BREAKPOINTS.includes(breakpoint) ? 'left' : 'top'
  const safeTotal = total > 0 ? total : 0
  const safeUsed = Math.max(0, Math.min(used, safeTotal))
  const percent = safeTotal === 0 ? 0 : Math.round((safeUsed / safeTotal) * 100)

  return (
    <div className="usage-modal__progress">
      <div className="usage-modal__progress-row">
        <span className="usage-modal__progress-label cgt-body-base">{label}</span>
        <span className="usage-modal__progress-count-group">
          <span className="usage-modal__progress-count cgt-body-base-semibold">
            {`${safeUsed}/${safeTotal}`}
          </span>
          {tooltip && (
            <Tooltip
              id={tooltipId}
              content={tooltip}
              tooltipClassName="usage-modal__tooltip"
              place={tooltipPlace}
              event="click"
            >
              <button type="button" className="usage-modal__tooltip-trigger" aria-label={tooltip}>
                <Icon svgComponent={InfoOutlined} color="dark" size="small" notSpaced />
              </button>
            </Tooltip>
          )}
        </span>
      </div>
      {/* role="progressbar" makes its descendants presentational, so it wraps only the
          bar itself - keeping the tooltip trigger above reachable by assistive tech. */}
      <div
        role="progressbar"
        aria-label={label}
        aria-valuenow={safeUsed}
        aria-valuemin={0}
        aria-valuemax={safeTotal}
      >
        <Progress progress={percent} height={12} isSpaced={false} useGradient />
      </div>
    </div>
  )
}

ProgressBar.propTypes = {
  label: string.isRequired,
  used: number.isRequired,
  total: number.isRequired,
  tooltip: string,
  tooltipId: string,
}

export default memo(ProgressBar)
